import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Container from "@/components/blocks/Container";
import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { docsComponents } from "@/lib/docs-theme";

interface DocLayoutProps {
  title: string;
  description: string;
  canonical: string;
  children: React.ReactNode;
}

export default function DocLayout({ title, description, canonical, children }: DocLayoutProps) {
  return (
    <>
      <Head>
        {generateNextSeo({
          title,
          description,
          canonical,
          openGraph: {
            title,
            description,
            url: canonical,
          },
        })}
      </Head>
      <div className={docsComponents.pageContainer}>
        <Header />
        <main className="flex-1">
          <Container>
            <div className="mx-auto max-w-4xl px-4 py-12">{children}</div>
          </Container>
        </main>
        <Footer />
      </div>
    </>
  );
}
